import { reactive, computed } from 'vue';

/**
 * Sayfalama durum verilerini oluşturur
 * @param {Object} documentState - Belge state verileri (bağımlılık)
 * @returns {Object} - Sayfalama state verileri
 */
export const createPaginationState = (documentState) => {
  // Sayfalama
  const pagination = reactive({
    currentPage: 1,
    pageSize: 10,
    total: 0,
    startItem: 1,
    endItem: 10
  });
  
  // Sayfalanmış belgeler
  const paginatedDocuments = computed(() => {
    // Filtrelenmiş belgeleri al
    let filteredDocs = [...documentState.documents.value];
    
    // Sayfalama hesapla
    pagination.total = filteredDocs.length;
    const start = (pagination.currentPage - 1) * pagination.pageSize;
    const end = Math.min(start + pagination.pageSize, filteredDocs.length);
    
    // Sayfalama bilgisini güncelle
    pagination.startItem = filteredDocs.length ? start + 1 : 0;
    pagination.endItem = end;
    
    return filteredDocs.slice(start, end);
  });

  return {
    pagination,
    paginatedDocuments
  };
};